import React from 'react'
import { useRef, useLayoutEffect, useEffect } from "react";
import {
  useDispatch,
  useSelector
} from 'react-redux';
 
import moment from 'moment'

import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5stock from "@amcharts/amcharts5/stock";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import { TLEOD_OHLCRAction } from '../redux/actions/VdrAction';
import { singleCompanyNoteAction } from '../redux/actions/userAction';


// Define source data
let data = [
  { Date: 1636495200000, Open: 106.75, High: 119.459999, Low: 95.199997, Close: 100.730003, Volume: 103679500 },
  { Date: 1636581600000, Open: 114.625, High: 125, Low: 108.010002, Close: 122.989998, Volume: 83668200 },
  { Date: 1636668000000, Open: 128.645004, High: 135.199997, Low: 125.25, Close: 129.949997, Volume: 50437500 },
  { Date: 1636927200000, Open: 130.800003, High: 152.529999, Low: 127.510002, Close: 149.360001, Volume: 64982300 },
  { Date: 1637013600000, Open: 163.800003, High: 179.470001, Low: 153.779999, Close: 172.009995, Volume: 94036600 },
  { Date: 1637100000000, Open: 160.880005, High: 163, Low: 140.350006, Close: 146.070007, Volume: 71765600 }
];



data = [
  {
    Date: 1689084000000,
    Open: 1775,
    High: 1783,
    Low: 1759,
    Close: 1767,
    Volume: 718668,
  },
  {
    // Date: 1689170400000,
    Date: 1689170400000,
    Open: 1763,
    High: 1787,
    Low: 1755,
    Close: 1773,
    Volume: 721398,
  },
];
// data = [{"date":"1684936800000","open":"1687","high":"1698","low":"1683","close":"1694","volume":"721713"},{"date":"1685023200000","open":"1710","high":"1722","low":"1697","close":"1714","volume":"715012"},{"date":"1685109600000","open":"1724","high":"1749","low":"1712","close":"1733","volume":"722961"},{"date":"1685368800000","open":"1740","high":"1763","low":"1731","close":"1740","volume":"726334"},{"date":"1685455200000","open":"1749","high":"1762","low":"1734","close":"1751","volume":"728103"},{"date":"1685541600000","open":"1752","high":"1785","low":"1734","close":"1777","volume":"719512"},{"date":"1685628000000","open":"1785","high":"1788","low":"1767","close":"1780","volume":"714107"},{"date":"1685714400000","open":"1779","high":"1822","low":"1775","close":"1813","volume":"711542"},{"date":"1685973600000","open":"1815","high":"1824","low":"1795","close":"1809","volume":"721139"},{"date":"1686060000000","open":"1817","high":"1821","low":"1785","close":"1806","volume":"726963"},{"date":"1686146400000","open":"1805","high":"1819","low":"1783","close":"1791","volume":"724510"},{"date":"1686232800000","open":"1782","high":"1797","low":"1773","close":"1784","volume":"728623"},{"date":"1686319200000","open":"1784","high":"1798","low":"1768","close":"1778","volume":"727832"},{"date":"1686578400000","open":"1771","high":"1795","low":"1756","close":"1786","volume":"721327"},{"date":"1686664800000","open":"1793","high":"1808","low":"1779","close":"1791","volume":"721844"},{"date":"1686751200000","open":"1786","high":"1804","low":"1768","close":"1773","volume":"721939"},{"date":"1686837600000","open":"1763","high":"1780","low":"1747","close":"1755","volume":"726787"},{"date":"1686924000000","open":"1738","high":"1761","low":"1723","close":"1759","volume":"740355"},{"date":"1687183200000","open":"1761","high":"1778","low":"1751","close":"1765","volume":"744602"},{"date":"1687269600000","open":"1772","high":"1816","low":"1768","close":"1814","volume":"750752"},{"date":"1687356000000","open":"1805","high":"1823","low":"1783","close":"1786","volume":"749208"},{"date":"1687442400000","open":"1791","high":"1813","low":"1786","close":"1797","volume":"756848"},{"date":"1687528800000","open":"1794","high":"1794","low":"1754","close":"1758","volume":"756594"},{"date":"1687788000000","open":"1758","high":"1789","low":"1754","close":"1780","volume":"751212"},{"date":"1687874400000","open":"1776","high":"1794","low":"1762","close":"1779","volume":"747392"},{"date":"1687960800000","open":"1779","high":"1793","low":"1762","close":"1768","volume":"753397"},{"date":"1688047200000","open":"1761","high":"1768","low":"1735","close":"1742","volume":"747020"},{"date":"1688133600000","open":"1747","high":"1766","low":"1742","close":"1761","volume":"750695"},{"date":"1688392800000","open":"1753","high":"1785","low":"1752","close":"1774","volume":"749533"},{"date":"1688479200000","open":"1777","high":"1791","low":"1770","close":"1787","volume":"740513"},{"date":"1688565600000","open":"1794","high":"1824","low":"1778","close":"1813","volume":"728419"},{"date":"1688652000000","open":"1815","high":"1822","low":"1795","close":"1812","volume":"720725"},{"date":"1688738400000","open":"1817","high":"1823","low":"1790","close":"1794","volume":"719345"},{"date":"1688997600000","open":"1794","high":"1809","low":"1777","close":"1780","volume":"724019"},{"date":"1689084000000","open":"1775","high":"1783","low":"1759","close":"1767","volume":"718668"},{"date":"1689170400000","open":"1763","high":"1787","low":"1755","close":"1773","volume":"721398"}]

const StockChart = () => {





  
  const dispatch = useDispatch()
  const { data: CompanyNoteData, loading: CompanyNoteLoading } = useSelector(state => state.singleCompanyNoteReducer);
  
const {
  EOD_OHLC:{
    data: EOD_OHLCData,
    loading: EOD_OHLCLoading
  },
} = useSelector(state=>state.TrendlyneDataReducer)




const [
  ChartData,
  setChartData
] = React.useState([]);





  const createChart = () => {
    return am5.Root.new("chart");
  };



  let compSlug = "INFY";

  useEffect(() => {
    
    if (CompanyNoteLoading) {
      var prams = { "CompanyID": 100251 };
      dispatch(singleCompanyNoteAction(prams));
  }

    if(CompanyNoteData?.Data && CompanyNoteData?.Data.length > 0){
      
    if(EOD_OHLCLoading){
        // console.log('compSlug >>>>>>>>>>> TLEOD_OHLCRAction > ', compSlug)
        dispatch(TLEOD_OHLCRAction(compSlug));
    }


    if(!EOD_OHLCLoading){

        // console.log('compSlug >>>>>>>>>>> chartRefToolbar > ', chartRefToolbar)

        let a0 = [];
        EOD_OHLCData.map((item, i0) => {
          if(i0 > 0 && i0 < 3){

            // let a00 = { Date: 1636495200000, Open: 106.75, High: 119.459999, Low: 95.199997, Close: 100.730003, Volume: 103679500 };
            // console.log(moment(item.date).valueOf())
            // let date1 = moment(item.date).valueOf();
            // let date1 = moment(item.date).format('YYYY-MM-DD');
            const d = new Date(item?.date);
            let date1 = d.valueOf();

            let a0000 = moment(item?.date).format('YYYY-MM-DD');
                a0000 = a0000+" 19:30:00"
            
            // console.log('date1 > ', new Date(a0000).valueOf(), moment(a0000).format('YYYY MM DD hh:mm:ss'))
            // console.log('date2 > ', moment(data[i0].Date).format('YYYY MM DD hh:mm:ss'))

            let a00 = { 
                        Date_0: item?.date,
                        Date: new Date(a0000).valueOf(),
                        Open: item.open_price,
                        High: item.high_price,
                        Low: item.low_price,
                        Close: item.close_price,
                        Volume: (item?.volume || item?.traded_qty),
                      };
              a0.push(a00)
          }
        })
        a0.sort((a, b)=>{
          return new Date(a.Date) - new Date(b.Date)
        })
        console.log('a0 >>>>>>>>>>>>>>>> ', a0)
        console.log('data >>>>>>>>>>>>>>>> ', data)
        setChartData(a0)
   
}
}


    // fetchData();
  }, [dispatch, EOD_OHLCLoading, CompanyNoteLoading]);




  
  useEffect(() => {

    if(ChartData.length > 0){


    data = ChartData;

    let root = createChart();
    let stockChart = root.container.children.push(am5stock.StockChart.new(root, {

    }));
    // Create a main stock panel (chart)
    // https://www.amcharts.com/docs/v5/charts/stock-chart/#Adding_panels
    let mainPanel = stockChart.panels.push(am5stock.StockPanel.new(root, {
      wheelY: "zoomX",
      panX: true,
      panY: true
    }));
    // Create axes
    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
    let valueAxis = mainPanel.yAxes.push(am5xy.ValueAxis.new(root, {
      renderer: am5xy.AxisRendererY.new(root, {})
    }));
    let dateAxis = mainPanel.xAxes.push(am5xy.GaplessDateAxis.new(root, {
      baseInterval: {
        timeUnit: "day",
        count: 1
      },
      renderer: am5xy.AxisRendererX.new(root, {})
    }));

    // Add series
    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
    let valueSeries = mainPanel.series.push(am5xy.LineSeries.new(root, {
      name: "STCK",
      valueXField: "Date",
      valueYField: "Close",
      xAxis: dateAxis,
      yAxis: valueAxis,
      legendValueText: "{valueY}"
    }));

    valueSeries.data.setAll(data);
    
    // Set main value series
    // https://www.amcharts.com/docs/v5/charts/stock-chart/#Setting_main_series
    stockChart.set("stockSeries", valueSeries);
    
    // Add a stock legend
    // https://www.amcharts.com/docs/v5/charts/stock-chart/stock-legend/
    let valueLegend = mainPanel.plotContainer.children.push(am5stock.StockLegend.new(root, {
      stockChart: stockChart
    }));
    valueLegend.data.setAll([valueSeries]);
    
    /**
     * Secondary (volume) panel
     */
    
    // Create a main stock panel (chart)
    // https://www.amcharts.com/docs/v5/charts/stock-chart/#Adding_panels
    let volumePanel = stockChart.panels.push(am5stock.StockPanel.new(root, {
      wheelY: "zoomX",
      panX: true,
      panY: true,
      height: am5.percent(30)
    }));

    // Create axes
    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
    let volumeValueAxis = volumePanel.yAxes.push(am5xy.ValueAxis.new(root, {
      numberFormat: "#.#a",
      renderer: am5xy.AxisRendererY.new(root, {})
    }));
    
    let  volumeDateAxis = volumePanel.xAxes.push(am5xy.GaplessDateAxis.new(root, {
      baseInterval: {
        timeUnit: "day",
        count: 1
      },
      renderer: am5xy.AxisRendererX.new(root, {})
    }));
    
    // Add series
    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
    let volumeSeries = volumePanel.series.push(am5xy.ColumnSeries.new(root, {
      name: "STCK",
      valueXField: "Date",
      valueYField: "Volume",
      xAxis: volumeDateAxis,
      yAxis: volumeValueAxis,
      legendValueText: "{valueY}"
    }));
    
    volumeSeries.data.setAll(data);
    
    // Set main value series
    // https://www.amcharts.com/docs/v5/charts/stock-chart/#Setting_main_series
    stockChart.set("volumeSeries", volumeSeries);


    // Add a stock legend
    // https://www.amcharts.com/docs/v5/charts/stock-chart/stock-legend/
    let volumeLegend = volumePanel.plotContainer.children.push(am5stock.StockLegend.new(root, {
      stockChart: stockChart
    }));
    volumeLegend.data.setAll([volumeSeries]);
    
    
    // Add cursor(s)
    // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
    mainPanel.set("cursor", am5xy.XYCursor.new(root, {
      yAxis: valueAxis,
      xAxis: dateAxis,
      snapToSeries: [valueSeries],
      snapToSeriesBy: "y!"
    }));
    
    volumePanel.set("cursor", am5xy.XYCursor.new(root, {
      yAxis: volumeValueAxis,
      xAxis: volumeDateAxis,
      snapToSeries: [volumeSeries],
      snapToSeriesBy: "y!"
    }));
    
    
    // Add scrollbar
    // https://www.amcharts.com/docs/v5/charts/xy-chart/scrollbars/
    let scrollbar = mainPanel.set("scrollbarX", am5xy.XYChartScrollbar.new(root, {
      orientation: "horizontal",
      height: 50
    }));
    stockChart.toolsContainer.children.push(scrollbar);
    
    let sbDateAxis = scrollbar.chart.xAxes.push(am5xy.GaplessDateAxis.new(root, {
      baseInterval: {
        timeUnit: "day",
        count: 1
      },
      renderer: am5xy.AxisRendererX.new(root, {})
    }));
    
    let sbValueAxis = scrollbar.chart.yAxes.push(am5xy.ValueAxis.new(root, {
      renderer: am5xy.AxisRendererY.new(root, {})
    }));
    
    let sbSeries = scrollbar.chart.series.push(am5xy.LineSeries.new(root, {
      valueYField: "Close",
      valueXField: "Date",
      xAxis: sbDateAxis,
      yAxis: sbValueAxis
    }));
    
    sbSeries.fills.template.setAll({
      visible: true,
      fillOpacity: 0.3
    });
    
    sbSeries.data.setAll(data);

  }

  }, [ChartData])


  return (
    <>
      <div id="chart" style={{ width: "100%", height: "460px" }}></div>
    </>
  )
}

export default StockChart
